import {Component, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {DictionariesService} from "../../../service";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {IIdDescription} from "../../../models";
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-dict-qref-action-443',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefAction443ViewComponent),
    multi: true
  }],
  template: `
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="id"
                         name="description"
                         [fieldsFromSearch]="'description'"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
<!--          {{ item.id }}-->
          {{ item.description }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
<!--          <div style="white-space: normal">-->
<!--            {{ item.id }}-->
            {{ item.description }}
<!--          </div>-->
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
  `
})
export class QrefAction443ViewComponent extends ViewDictionaryBase<IIdDescription> {
  getDictionary = this.dictSrv.getQrefAction443List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }

  ngOnInit() {
    if (this.getDictionary)
      this.dictionary = this.getDictionary.pipe(
        map(page => page.content.map(element => ({ ...element, id: element.id.toString() })))
      );
  }
}
